import { readOrganizationTeam } from '@usehatchapp/javascript-sdk';
import camelcaseKeys from 'camelcase-keys';
import isCorrectHatchIdFormat from 'utils/isCorrectHatchIdFormat';
import validateSchema from 'utils/validateSchema';

import { constants as freshConstants } from '../../fresh';
import { ORGANIZATION_TEAM } from '../../fresh/schema';
import { constants as teamsConstants } from '../constants';
import { teamMemberSchema } from '../schema';

export const doReadTeamByOrganization =
  ({ organizationId } = {}) =>
  async ({ dispatch, request }) => {
    const {
      READ_TEAM_BY_ORGANIZATION_FAILURE,
      READ_TEAM_BY_ORGANIZATION_REQUEST,
      READ_TEAM_BY_ORGANIZATION_SUCCESS,
    } = teamsConstants;
    const { SET_FRESH_ORGANIZATION_KEY } = freshConstants;

    try {
      if (!isCorrectHatchIdFormat(organizationId)) {
        throw new Error('Invalid organizationId format');
      }

      // tell state we're fetching team by organization
      dispatch({ type: READ_TEAM_BY_ORGANIZATION_REQUEST });

      // fetch team member objects as array
      const teamResponse = await request(readOrganizationTeam, {
        disabled: true,
        organizationId,
      });

      // validate team members against schema
      const validatedTeam = [];
      if (Array.isArray(teamResponse)) {
        for (let i = 0, len = teamResponse.length; i < len; i += 1) {
          const validatedTeamMember = validateSchema({
            payload: camelcaseKeys(teamResponse[i]),
            schema: teamMemberSchema,
          });
          validatedTeam.push(validatedTeamMember);
        }
      }

      // reduce team members into store
      dispatch({
        actions: [
          {
            payload: {
              organizationId,
              teamByOrganization: validatedTeam,
            },
            type: READ_TEAM_BY_ORGANIZATION_SUCCESS,
          },
          {
            payload: {
              fresh: true,
              key: ORGANIZATION_TEAM,
              organizationIDs: [organizationId],
            },
            type: SET_FRESH_ORGANIZATION_KEY,
          },
        ],
        type: 'BATCH_ACTIONS',
      });
    } catch (error) {
      dispatch({ error, type: READ_TEAM_BY_ORGANIZATION_FAILURE });
    }
  };
